import { useExcursionFiltersStore } from '@/entities/filter/store/excursion';
import { useComponentI18n } from '@/shared/composables/useComponentI18n.ts';
import { getFilterTitle } from '@/features/filter/dates/lib/title.ts';
import { sortDurationIntervalValues } from '@/entities/filter/lib/sort';
import type ru from '@/features/filter/duration/i18n/ru.json';

type TSchema = typeof ru;

export function useExcursionAdditionalFilterOptions(messages: TSchema) {
  const filtersStore = useExcursionFiltersStore();

  const { t } = useComponentI18n({ ru: messages });

  const isActiveDatesFilter = computed(
    () =>
      filtersStore.searchState.date.from ||
      filtersStore.searchState.date.to ||
      filtersStore.searchState.date.persons > 1,
  );

  const isActiveStartTimeIntervalFilter = computed(() => filtersStore.searchState.startTimeInterval?.length);
  const isActiveDurationIntervalFilter = computed(() => filtersStore.searchState.durationInterval?.length);
  const isActiveChildrenFilter = computed(() => filtersStore.searchState.childrenAllowed);

  const childrenTitle = computed(() => t('output.children'));
  const dateTitle = computed(() =>
    getFilterTitle(
      filtersStore.searchState.date.from,
      filtersStore.searchState.date.to,
      filtersStore.searchState.date.persons,
    ),
  );

  const startTimeIntervalTitle = computed(() => {
    return filtersStore.searchState.startTimeInterval.reduce((acc, item, index) => {
      const title = t(`output.${item}`);

      return index ? acc + `, ${title.toLowerCase()}` : title;
    }, '');
  });

  const durationIntervalTitle = computed(() => {
    const sortedDurationInterval = sortDurationIntervalValues(filtersStore.searchState.durationInterval);

    return sortedDurationInterval.reduce((acc, item, index) => {
      const title = t(`output.${item}`);

      return index ? acc + `, ${title.toLowerCase()}` : title;
    }, '');
  });

  return {
    isActiveDatesFilter,
    isActiveStartTimeIntervalFilter,
    isActiveDurationIntervalFilter,
    isActiveChildrenFilter,
    childrenTitle,
    dateTitle,
    startTimeIntervalTitle,
    durationIntervalTitle,
  };
}
